import init from '../../../js/init';

const name = 'timepicker';
const selector = 'input.timepicker';
init(Drupal, name, selector, root => {
  var args = {}

  var tpicker = new Timepicker(root, args)

  function Timepicker(element, args) {

    this.initialized = false
    this.element = null
    this.elements = {}
    this.timepicker = null
    this.time = new Date()
    this.time.setMinutes(0);
    this.settings = {
      format: true,
      meridiem: true,
      minTime: new Date(new Date().toISOString().substring(0, 10) + 'T00:00:00'),
      maxTime: new Date(new Date().toISOString().substring(0, 10) + 'T24:00:00'),
      onChange: false
    }
    this.active = false

    this.buildTimepicker = function () {
      var wrapper = document.createElement('div')
      var elements = ['hour', 'minute', 'meridiem']

      wrapper.className = 'timepicker__wrapper rounded-xl border-gray-60 shadow-skim'
      wrapper.setAttribute('id', 'tp_' + (Math.floor(Math.random() * 100) + 1))

      if (!Object.keys(this.elements).length) {
        for (var e = 0; e < elements.length; e++) {
          this.elements[elements[e]] = document.createElement('div')
          this.elements[elements[e]].className = 'timepicker__' + elements[e]
          var up = document.createElement('div')
          up.appendChild(document.createElement('div'))
          var display = document.createElement('p')
          var down = document.createElement('div')
          down.appendChild(document.createElement('div'))
          up.className = 'timepicker__button timepicker__button__up'
          display.className = 'display'
          down.className = 'timepicker__button timepicker__button__down'
          if (elements[e] === 'minute') {
            up.dataset.step = 15;
            down.dataset.step = 15;
          }
          if (this.settings.arrowColor) {
            up.childNodes[0].style['border-bottom-color'] = this.settings.arrowColor
            down.childNodes[0].style['border-top-color'] = this.settings.arrowColor
          }
          this.elements[elements[e]].appendChild(up)
          this.elements[elements[e]].appendChild(display)
          this.elements[elements[e]].appendChild(down)
        }
      }

      this.timepicker = wrapper
      this.element.parentNode.insertBefore(wrapper, this.element.nextSibling)
      this.addListeners()
      this.render()
    }

    this.render = function () {
      var wrapper = this.cleanWrapper(this.timepicker)
      if (this.settings.meridiem) {
        wrapper.className = wrapper.className.indexOf(' timepicker__wrapper-full') >= 0 ? wrapper.className : wrapper.className + ' timepicker__wrapper-full'
      }

      for (var e = 0; e < Object.keys(this.elements).length; e++) {
        var key = Object.keys(this.elements)[e]
        var element = this.elements[key]
        var func = 'get' + key.charAt(0).toUpperCase() + key.slice(1)
        element.querySelector('.display').innerText = this[func]()
        if (Object.keys(this.elements)[e] === 'meridiem' && !this.settings.meridiem) {
          continue
        }
        wrapper.appendChild(element)
      }

      this.timepicker = wrapper
      this.updateInput()
    }

    this.cleanWrapper = function (wrapper) {
      while (wrapper.hasChildNodes()) {
        wrapper.removeChild(wrapper.lastChild)
      }
      return wrapper
    }

    this.handleClick = function (e) {
      var element = e.currentTarget
      var parent = element.parentNode.className.replace('timepicker__', '')
      var add = element.className.indexOf('up') !== -1
      var amount =  parseInt(element.dataset.step);
      this.updateTime(parent, add, amount)
      this.triggerFormChangeEvent(e, element);
    }

    this.triggerFormChangeEvent = function (e, element) {
      e.stopPropagation();
      e.preventDefault();
      var event = new Event('change');
      element.closest('form').dispatchEvent(event);
    }

    this.validateInput = function (e) {
      var value = e.currentTarget.value
      var date = value.length ? new Date(new Date().toDateString() + ' ' + value) : false
      if (date && !isNaN(date.getTime())) {
        this.time = date
      }
      if (!this.validateTime()) {
        var after = date.getTime() > this.settings.maxTime.getTime()
        date = after ? new Date(this.settings.maxTime) : new Date(this.settings.minTime)
        after ? date.setMinutes(date.getMinutes() - 1) : date.setMinutes(date.getMinutes() + 1)
        this.time = date
      }
      this.render()
    }

    this.updateTime = function (method, add, amount) {
      amount = amount || 1
      switch (method) {
        case 'meridiem' :
          this.time.getHours() > 12 ? this.time.setHours(this.time.getHours() - 12) : this.time.setHours(this.time.getHours() + 12)
          break
        default :
          if (add) {
            this.add(method, amount)
          } else {
            this.subtract(method, amount)
          }
      }
      if (!this.validateTime()) {
        var date = add ? new Date(this.settings.minTime) : new Date(this.settings.maxTime)
        add ? date.setMinutes(date.getMinutes() + 1) : date.setMinutes(date.getMinutes() - 1)
        this.time = date
      }
      this.render()
    }

    this.add = function (method, amount) {
      amount = amount || 1
      switch (method) {
        case 'minute' :
          this.time.setMinutes(this.time.getMinutes() + amount)
          break
        case 'hour' :
          this.time.setHours(this.time.getHours() + amount)
          break
      }
    }

    this.subtract = function (method, amount) {
      amount = amount || 1
      switch (method) {
        case 'minute' :
          this.time.setMinutes(this.time.getMinutes() - amount)
          break
        case 'hour' :
          this.time.setHours(this.time.getHours() - amount)
          break
      }
    }

    this.validateTime = function () {
      if (this.settings.minTime) {
        this.time.setDate(new Date().getDate())
        return this.time.getTime() < this.settings.maxTime.getTime() && this.time.getTime() > this.settings.minTime.getTime()
      }
      return true
    }

    this.updateInput = function (parent) {
      if (this.initialized) {
        this.element.value = this.buildString()
        this.element.form.formatted_dates[this.element.name] = this.buildFormattedString()
      }
    }

    this.buildString = function () {
      return (this.getHour() + ":" + this.getMinute() + ' ' + this.getMeridiem()).trim()
    }

    this.buildFormattedString = function () {
      return (this.getFormattedHour() + ":" + this.getMinute()).trim()
    }

    this.toggleActive = function (e) {
      if (e.target === this.element) {
        if (!this.initialized) {
          this.initialized = true
          this.updateInput()
        }
        this.updateBounds(this.timepicker, e.target)
        this.active = true
        this.triggerFormChangeEvent(e, element);
      } else if (typeof e.target.className === 'string' &&
        e.target.className.indexOf('timepicker__') === -1 &&
        typeof e.target.parentElement.className === 'string' &&
        e.target.parentElement.className.indexOf('timepicker__') === -1
      ) {
        this.active = false
      }
      this.timepicker.className = this.active ? this.timepicker.className.indexOf(' timepicker__wrapper-active') >= 0 ? this.timepicker.className : this.timepicker.className + ' timepicker__wrapper-active' : this.timepicker.className.replace(' timepicker__wrapper-active', '')
    }

    this.updateBounds = function () {
      var bounds = this.element.getBoundingClientRect()
      this.timepicker.style.top = this.element.offsetTop + this.element.innerHeight + 'px'
      this.timepicker.style.width = bounds.width + 'px'
    }

    this.addListeners = function () {
      var elements = Object.keys(this.elements)
      for (var e = 0; e < elements.length; e++) {
        var element = this.elements[elements[e]]
        var buttons = [].slice.call(element.childNodes).filter(function (node) {
          return node.className.indexOf('button') !== -1
        })
        for (var c = 0; c < buttons.length; c++) {
          var button = buttons[c]
          button.addEventListener('click', this.handleClick.bind(this))
        }
      }
      this.element.addEventListener('change', this.validateInput.bind(this))
      document.body.addEventListener('click', this.toggleActive.bind(this))
      window.addEventListener('resize', this.updateBounds.bind(this))
    }

    this.getTime = function () {
      return this.time
    }

    this.getHour = function () {
      if (!this.settings.format) {
        return this.time.getHours() < 10 ? '0' + this.time.getHours() : this.time.getHours()
      } else {
        return this.time.getHours() > 12 ? this.time.getHours() % 12 : this.time.getHours() === 0 ? 12 : this.time.getHours()
      }
    }

    this.getFormattedHour = function () {
      return this.time.getHours() < 10 ? '0' + this.time.getHours() : this.time.getHours()
    }

    this.getMinute = function () {
      var minutes = this.time.getMinutes()
      return minutes < 10 ? '0' + minutes : minutes
    }

    this.getMeridiem = function () {
      if (!this.settings.meridiem) {
        return ''
      } else {
        return this.time.getHours() >= 12 ? 'pm' : 'am'
      }
    }

    this.init = function () {
      if (element.length) {
        console.warn('Timepicker selector must be for a specific element, not a list of elements.')
        return
      }
      this.element = element
      this.element.form.formatted_dates = {}
      this.element.form.addEventListener('formdata', (e) => {
        const formdata = e.formData;
        const alter_fields = e.target.formatted_dates ? e.target.formatted_dates : {}
        for (const [key, value] of Object.entries(alter_fields)) {
          if (formdata.has(key)) {
            formdata.set(key, value)
          }
        }
      })
      this.buildTimepicker()
    }

    this.init()

  }
});
